import { motion } from "framer-motion";
import NeuralHero from "../three/NeuralHero";

export default function PageHero({ eyebrow, title, subtitle, image, children, neural = false }) {
  return (
    <section className="relative overflow-hidden px-6 pb-16 pt-40 lg:pb-24 lg:pt-48" data-testid="page-hero">
      {image && (
        <div className="pointer-events-none absolute inset-0 z-0">
          <img src={image} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-ink-900/80 via-ink-900/85 to-ink-900" />
        </div>
      )}
      {neural && <NeuralHero className="z-0 opacity-80 lg:left-[46%]" />}
      <div className="pointer-events-none absolute left-1/4 top-10 z-0 h-80 w-[500px] radial-glow" />
      <div className="relative z-10 mx-auto max-w-7xl">
        {eyebrow && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-5 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-sky-400"
          >
            <span className="h-px w-8 bg-sky-400/60" />
            {eyebrow}
          </motion.div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl font-heading text-4xl font-bold leading-[1.05] tracking-tighter text-white sm:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300 lg:text-lg"
          >
            {subtitle}
          </motion.p>
        )}
        {children && <div className="mt-9">{children}</div>}
      </div>
    </section>
  );
}
